import { render } from "./patients-list.vue?vue&type=template&id=a7bd4690&scoped=true"
import script from "./patients-list.vue?vue&type=script&lang=js"
export * from "./patients-list.vue?vue&type=script&lang=js"

import "./patients-list.vue?vue&type=style&index=0&id=a7bd4690&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7bd4690"]])

export default __exports__